import type { CountryCode } from '@gql/graphql';
import type {
  CardItemShelterData,
  FiltersWithModalData,
  SelectOption,
  StoreCardItemPromoData,
} from '@presentation/components';
import type { MouseEventHandler } from 'react';

export interface ShelterListPageFormValues {
  countries?: CountryCode[];
  spokenLanguages?: string[];
  regions?: string[];
}

export interface ShelterListPageFormOptions {
  regions: SelectOption<string>[];
}

export interface ShelterListPageData {
  items?: (CardItemShelterData | StoreCardItemPromoData)[];
  loading?: boolean;
  options: ShelterListPageFormOptions;

  loadMoreLoading?: boolean;
  onLoadMoreClick?: MouseEventHandler;
  loadMoreText?: string;
  canLoadMore?: boolean;

  filtersModal: FiltersWithModalData;
}

export interface ShelterListPageProps extends ShelterListPageData {}
